module.exports = __webpack_public_path__ + "static/media/Follower_Button-2.8e8c0f45.png";